/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureSnapshotProgress {
    getFixupPrototypeFunction() { return TagPostureSnapshotProgress.fixupPrototype; }

    static newInstance(model: Partial<TagPostureSnapshotProgress>): TagPostureSnapshotProgress {
        let obj = Object.assign(new TagPostureSnapshotProgress(), model);
        TagPostureSnapshotProgress.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureSnapshotProgress>): TagPostureSnapshotProgress {
        if (!model) return null;
        return TagPostureSnapshotProgress.newInstance(<TagPostureSnapshotProgress> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureSnapshotProgress) {
        if (!obj) return;

        models.TagPostureSnapshotProgress.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureSnapshotProgress): boolean {
        Object.setPrototypeOf(obj, TagPostureSnapshotProgress.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_cloud_accounts === undefined) {
            this.total_cloud_accounts = 0;
        }
        if (this.processed_cloud_accounts === undefined) {
            this.processed_cloud_accounts = 0;
        }
    }

    /**
     * Total number of cloud accounts in the snapshot
     */
    total_cloud_accounts: number;

    /**
     * Number of cloud accounts that have been processed already
     */
    processed_cloud_accounts: number;

}
